"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCirrusRequest = void 0;
const graphql_1 = require("graphql");
const sha1_1 = __importDefault(require("sha1"));
function buildCirrusRequest({ operation, endpoint, shouldHash, }) {
    return {
        messageType: 'GraphQLRequest',
        locationAddress: { resourceType: 'LocationAddress', locationId: getLocationId(endpoint) },
        query: shouldHash ? hashedQuery(operation.query) : serializeQuery(operation.query),
        vars: JSON.stringify(operation.variables),
        isLS: getIsLS(endpoint),
    };
}
exports.buildCirrusRequest = buildCirrusRequest;
function getLocationId(endpoint) {
    var _a;
    switch (endpoint.type) {
        case 'GATEWAY':
            return endpoint.locationId;
        case 'LINK_SERVER':
            switch ((_a = endpoint.server) === null || _a === void 0 ? void 0 : _a.type) {
                case 'peering':
                    return 'type=peering';
                case 'locationLinkServer':
                    return endpoint.server.locationId;
                default:
                    return '*';
            }
    }
}
function getIsLS(endpoint) {
    switch (endpoint.type) {
        case 'GATEWAY':
            return false;
        case 'LINK_SERVER':
            return true;
    }
}
function hashedQuery(query) {
    const hash = sha1_1.default(serializeQuery(query)).toString();
    return `sha ${hash.substring(hash.length - 6)}`;
}
function serializeQuery(query) {
    return graphql_1.print(query).trim();
}
//# sourceMappingURL=cirrus-request.js.map